import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  GET_ALL_USERS,
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
} from "./actionTypes"
import { apiError } from "store/actions"
import { changePreloader } from "../layout/actions"
import { showMessage } from "components/Common/Toaster"
import {
  getAllAdminUsersCall,
  createUserCall,
  deleteUserCall,
  updateUserCall,
} from "../../helpers/repository"
import { getAllAdminUsersResponseSuccess, getAllUsers } from "./actions"
import { showErrorMessages } from "helpers/helpers"
function* attempGetAllUsers(action) {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllAdminUsersCall, action.payload)
    yield put(getAllAdminUsersResponseSuccess(response.data.data))
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}
function* attemptCreateUser(action) {
  const { toggle } = action

  try {
    const response = yield call(createUserCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllUsers(action.payload.currentUser))
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

function* attemptUpdateUser(action) {
  const { toggle } = action
  try {
    const response = yield call(updateUserCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllUsers(action.payload.currentUser))
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

function* attemptDeleteUser(action) {
  try {
    const response = yield call(
      deleteUserCall,
      action.payload.type,
      action.payload.id
    )
    showMessage("success", response?.data?.message)
    yield put(getAllUsers(action.payload.type))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* UsersSaga() {
  yield takeEvery(GET_ALL_USERS, attempGetAllUsers)
  yield takeEvery(CREATE_USER, attemptCreateUser)
  yield takeEvery(DELETE_USER, attemptDeleteUser)
  yield takeEvery(UPDATE_USER, attemptUpdateUser)
}

export default UsersSaga
